import React from "react";
import axios from "axios";
import { baseUrl } from "../Api/Api";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import AddCommentIcon from "@material-ui/icons/AddComment";
import { yellow } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    fontSize: 36,
    fontWeight: 800,
    color: "#000",
    lineHeight: 1.15,
    [theme.breakpoints.up("md")]: {
      fontSize: 58,
    },
  },
  card: {
    borderRadius: theme.shape.borderRadius,
    background: "#fff",
    padding: theme.spacing(2),
    "& .email": {
      fontSize: 13,
    },
    "& .date": {
      fontSize: 13,
      fontStyle: "italic",
      color: "rgba(0, 0, 0, 0.5)",
    },
    "& .description": {
      marginTop: theme.spacing(2),
      fontSize: 14,
    },
  },
}));

const Review = () => {
  const classes = useStyles();

  const [reviews, setReviews] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [form, setForm] = React.useState({
    email: "",
    rating: 3,
    text: "",
  });
  const [formError, setFormError] = React.useState({});
  const [submitted, setSubmitted] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSubmitted(false);
  };

  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleClickStar = (value) => {
    setForm({ ...form, rating: value });
  };

  const handleSubmit = () => {
    let valid = true;
    let errors = {};
    if (form.email.trim().length === 0) {
      valid = false;
      errors.email = "Vyplňte prosím jméno.";
    }
    if (form.text.trim().length === 0) {
      valid = false;
      errors.text = "Vyplňte prosím text recenze.";
    }
    setFormError(errors);
    if (valid) {
      const url = baseUrl + "/review";
      axios
        .post(url, form)
        .then((response) => {
          if (response.status === 201) {
            loadReviews();
            setForm({ email: "", text: "", rating: 3 });
            setSubmitted(true);
          }
        })
        .catch((error) => {});
    }
  };

  const loadReviews = () => {
    const url = baseUrl + "/review";
    axios
      .get(url)
      .then((response) => {
        setReviews(response.data);
      })
      .catch((error) => {});
  };

  React.useEffect(() => {
    loadReviews();
  }, []);

  return (
    <>
      <Container maxWidth={"lg"}>
        <Box>
          <Grid
            container
            spacing={2}
            style={{ marginTop: 8, marginBottom: 16, alignItems: "center" }}
            className={"landingPageView"}
          >
            <Grid item xs={12} md={6}>
              <Typography variant={"h1"}>
                🔥 Recenze od těch, co to přežili 🔥
              </Typography>
              <Typography>
                Nejsou to žádný PR kecy, jen čistá realita studentů, co se
                stejně jako ty snažili projít účtem bez ztráty kreditu i
                duševního zdraví. Takže jestli ještě váháš, jestli do toho jít,
                čti dál. A pokud už ses zachránil díky mně, hoď mi taky recenzi
                – odměnou ti bude dobrá karma a Fífova nehynoucí vděčnost (nebo
                aspoň uznalý pokývání hlavou). 😆
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} style={{ textAlign: "center" }}>
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/kY7RKUgHjbI?si=JSwrtSq3t1jwbpfa"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </Grid>
          </Grid>

          <Grid container spacing={2} className={"landingPageView"}>
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Typography variant={"h1"}>
                Nedostali slevu, přesto o mně tohle řekli
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            style={{ marginTop: 8, marginBottom: 16, alignItems: "center" }}
            className={"landingPageView"}
          >
            <Grid item xs={6} style={{ textAlign: "center" }}>
              <img src={"/reviews_google.png"} height={226} />
            </Grid>
            <Grid item xs={6} style={{ textAlign: "center" }}>
              <img src={"/reviews_google.png"} height={226} />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            {reviews
              .sort((a, b) => {
                return b.createdAt.localeCompare(a.createdAt);
              })
              .map((r) => {
                const d = new Date(r.createdAt);
                return (
                  <>
                    <Grid item md={4} sm={6} xs={12}>
                      <Box className={classes.card}>
                        <Box display={"flex"}>
                          <Box flexGrow={1}>
                            <Box className={"email"}>{r.email}</Box>
                            <Box className={"date"}>
                              {[
                                d.getDate(),
                                d.getMonth() + 1,
                                d.getFullYear(),
                              ].join(". ")}
                            </Box>
                          </Box>
                          <Box>
                            {[...Array(r.rating).keys()].map((s) => {
                              return (
                                <StarIcon style={{ color: yellow["500"] }} />
                              );
                            })}
                            {[...Array(5 - r.rating).keys()].map((s) => {
                              return (
                                <StarBorderIcon
                                  style={{ color: yellow["500"] }}
                                />
                              );
                            })}
                          </Box>
                        </Box>
                        <Box className={"description"}>{r.text}</Box>
                      </Box>
                    </Grid>
                  </>
                );
              })}
          </Grid>
          <Box mt={4} mb={4} display={"flex"} justifyContent={"center"}>
            <Button
              size={"large"}
              variant={"contained"}
              color={"primary"}
              startIcon={<AddCommentIcon />}
              onClick={handleOpen}
            >
              Přidat novou recenzi
            </Button>
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Přidat novou recenzi</DialogTitle>
              <DialogContent>
                {submitted && (
                  <DialogContentText>Díky za recenzi!</DialogContentText>
                )}
                {!submitted && (
                  <>
                    <Box mb={2}>
                      <TextField
                        size={"small"}
                        variant={"outlined"}
                        label={"Jméno"}
                        fullWidth
                        name={"email"}
                        value={form.email}
                        onChange={handleChange}
                        error={formError.hasOwnProperty("email")}
                        helperText={
                          formError.hasOwnProperty("email")
                            ? formError.email
                            : ""
                        }
                      />
                    </Box>
                    <Box mb={2}>
                      <TextField
                        size={"small"}
                        variant={"outlined"}
                        multiline
                        rows={4}
                        label={"Text recenze"}
                        fullWidth
                        name={"text"}
                        value={form.text}
                        onChange={handleChange}
                        error={formError.hasOwnProperty("text")}
                        helperText={
                          formError.hasOwnProperty("text") ? formError.text : ""
                        }
                      />
                    </Box>
                    <Box
                      mb={4}
                      display={"flex"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <Box mr={4}>
                        <Typography variant={"body2"}>Hodnocení</Typography>
                      </Box>
                      <Box>
                        {[1, 2, 3, 4, 5].map((r) => {
                          return (
                            <React.Fragment key={r}>
                              {r <= form.rating ? (
                                <StarIcon
                                  color={"primary"}
                                  fontSize={"large"}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleClickStar(r);
                                  }}
                                />
                              ) : (
                                <StarBorderIcon
                                  color={"primary"}
                                  fontSize={"large"}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleClickStar(r);
                                  }}
                                />
                              )}
                            </React.Fragment>
                          );
                        })}
                      </Box>
                    </Box>
                  </>
                )}
              </DialogContent>
              <DialogActions>
                {submitted && (
                  <Button
                    variant={"text"}
                    color={"secondary"}
                    size={"small"}
                    onClick={handleClose}
                  >
                    Zavřít
                  </Button>
                )}
                {!submitted && (
                  <>
                    <Button
                      variant={"text"}
                      color={"secondary"}
                      size={"small"}
                      onClick={handleClose}
                    >
                      Zrušit
                    </Button>
                    <Button
                      variant={"contained"}
                      color={"primary"}
                      onClick={handleSubmit}
                    >
                      Přidat recenzi
                    </Button>
                  </>
                )}
              </DialogActions>
            </Dialog>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Review;
